import { types, actions } from './requests'
export const CREATETASK_TYPES = {
    ...types('CREATETASK'),
}
export const CREATETASK_ACTIONS = {
    ...actions('CREATETASK'),
}